/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { IdentityRef } from './';
import {
    IdentityRefFromJSON,
    IdentityRefFromJSONTyped,
    IdentityRefToJSON,
} from './';

/**
 * 
 * @export
 * @interface AdvancedSearchOwner
 */
export interface AdvancedSearchOwner {
    /**
     * 
     * @type {IdentityRef}
     * @memberof AdvancedSearchOwner
     */
    identity?: IdentityRef;
    /**
     * 
     * @type {IdentityRef}
     * @memberof AdvancedSearchOwner
     */
    onBehalfOf?: IdentityRef;
    /**
     * 
     * @type {string}
     * @memberof AdvancedSearchOwner
     */
    correlationId?: string;
}

/**
 * Check if a given object implements the AdvancedSearchOwner interface.
 */
export function instanceOfAdvancedSearchOwner(value: object): value is AdvancedSearchOwner {
    return true;
}

export function AdvancedSearchOwnerFromJSON(json: any): AdvancedSearchOwner {
    return AdvancedSearchOwnerFromJSONTyped(json, false);
}

export function AdvancedSearchOwnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdvancedSearchOwner {
    if (json == null) {
        return json;
    }
    return {
        
        'identity': json['identity'] == null ? undefined : IdentityRefFromJSON(json['identity']),
        'onBehalfOf': json['onBehalfOf'] == null ? undefined : IdentityRefFromJSON(json['onBehalfOf']),
        'correlationId': json['correlationId'] == null ? undefined : json['correlationId'],
    };
}

export function AdvancedSearchOwnerToJSON(value?: AdvancedSearchOwner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'identity': IdentityRefToJSON(value['identity']),
        'onBehalfOf': IdentityRefToJSON(value['onBehalfOf']),
        'correlationId': value['correlationId'],
    };
}

